export default __webpack_public_path__ + "static/media/istockphoto-469732852-612x612.d5ffee82.jpg";